import { store, getContext } from "@wordpress/interactivity";

const { state } = store("tag-posts", {
  state: {
    get visibleIds() {
      return new Set(state.posts.slice(0, state.visibleCount).map((p) => p.id));
    },

    get getItemDisplay() {
      const { postId } = getContext();
      return state.visibleIds.has(postId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.posts.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.posts.length > state.visibleCount ? "flex" : "none";
    },
  },

  actions: {
    loadMore() {
      state.visibleCount += state.perPage;
    },
  },
});
